module.exports = __webpack_public_path__ + "static/header-bottom-ce27630b0594b3151ad62b61f98a2df4.svg";